/**
 * @param {MaybeRef<string>} status
 * @param {{type: ?string}} options
 * @returns {{textStyle: Ref<string>, bgStyle: Ref<string>}}
 */
/**
 * Pure function to compute status colours.
 * @param {string} status
 * @param {{type: ?string}} options
 * @returns {{ textStyle: string, bgStyle: string }}
 */
export function getStatusColours(status, options = { type: null }) {
    const stat = status;
    let textStyle = '';
    let bgStyle = '';
    switch (options?.type?.toUpperCase()) {
        case 'ORDER':
            switch (stat?.toUpperCase()) {
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
            }
            break;
        case 'ICON':
            switch (stat?.toUpperCase()) {
                case 'READY':
                    textStyle = 'text-muval-dusk-2';
                    break;
                case 'BOOKED':
                    textStyle = 'text-muval-dusk-2';
                    break;
                case 'COMPLETED':
                    textStyle = 'text-muval-lime-1';
                    break;
                case 'ACCEPTED':
                    textStyle = 'text-muval-green-1';
                    break;
                case 'PENDING':
                    textStyle = 'text-muval-amber';
                    break;
                case 'PROCESSING':
                    textStyle = 'text-muval-blue-1';
                    break;
                case 'PAID':
                    textStyle = 'text-muval-success';
                    break;
                case 'FAILED':
                    textStyle = 'text-muval-red-1';
                    break;
                case 'QUOTED':
                    textStyle = 'text-muval-purple-1';
                    break;
                case 'APPROVED':
                    textStyle = 'text-muval-blue-1';
                    break;
                default:
                    textStyle = 'text-muval-gray-3';
                    break;
            }
            break;
        case 'PAYOUT':
            switch (stat?.toUpperCase()) {
                case 'PENDING':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'QUEUED':
                    textStyle = 'text-muval-purple-1';
                    bgStyle = 'bg-muval-purple-2';
                    break;
                case 'PAUSED':
                    textStyle = 'text-muval-brown-1';
                    bgStyle = 'bg-muval-brown-2';
                    break;
                case 'PROCESSING':
                    textStyle = 'text-muval-dusk-2';
                    bgStyle = 'bg-muval-sky-2';
                    break;
                case 'PROCESSED':
                    textStyle = 'text-muval-dusk-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'PAID':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'FAILED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'CANCELLED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
            }
            break;
        case 'COMPANY':
            switch (stat?.toUpperCase()) {
                case 'PENDING':
                    textStyle = 'text-yellow-800';
                    bgStyle = 'bg-yellow-100';
                    break;
                case 'ONBOARDED':
                    textStyle = 'text-teal-800';
                    bgStyle = 'bg-teal-100';
                    break;
                case 'VETTED':
                    textStyle = 'text-green-800';
                    bgStyle = 'bg-green-100';
                    break;
                case 'REJECTED':
                    textStyle = 'text-pink-800';
                    bgStyle = 'bg-pink-100';
                    break;
                case 'RESTRICTED':
                    textStyle = 'text-purple-800';
                    bgStyle = 'bg-purple-100';
                    break;
                case 'REMOVED':
                    textStyle = 'text-red-800';
                    bgStyle = 'bg-red-100';
                    break;
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
            }
            break;
        case 'UTILITIES':
            switch (stat?.toUpperCase()) {
                // purple - scheduled internally
                case 'FOLLOW_UP:':
                case 'INTERNAL_CALLBACK:':
                case 'INTERNAL_CALLBACK:SUCCESS':
                    textStyle = 'text-muval-purple-1';
                    bgStyle = 'bg-muval-purple-2';
                    break;
                // orange - pending or awaiting action via API
                case 'PENDING':
                case 'CONTACT_ASAP:':
                case 'CONTACT_NEXT_WEEK:':
                case 'CONTACT_REMIND_LATER:':
                case 'SCHEDULED_CALLBACK:':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                // blue - success via warm transfer
                case 'WARM_TRANSFER:':
                    textStyle = 'text-muval-dusk-2';
                    bgStyle = 'bg-muval-sky-2';
                    break;
                // green - success via API
                case 'CONTACT_ASAP:SUCCESS':
                case 'CONTACT_NEXT_WEEK:SUCCESS':
                case 'CONTACT_REMIND_LATER:SUCCESS':
                case 'SCHEDULED_CALLBACK:SUCCESS':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                // red - blocked before sending via API
                // red - failure after sending via API
                // red - not interested after sending via API
                case 'CONTACT_ASAP:BLOCKED':
                case 'CONTACT_NEXT_WEEK:BLOCKED':
                case 'CONTACT_REMIND_LATER:BLOCKED':
                case 'SCHEDULED_CALLBACK:BLOCKED':
                case 'CONTACT_ASAP:FAILURE':
                case 'CONTACT_NEXT_WEEK:FAILURE':
                case 'CONTACT_REMIND_LATER:FAILURE':
                case 'SCHEDULED_CALLBACK:FAILURE':
                case 'INTERNAL_CALLBACK:FAILURE':
                case 'NOT_INTERESTED:SUCCESS':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                // brown - not interested if not sent via API, or not applicable
                case 'NOT_INTERESTED:':
                case 'NOT_INTERESTED:FAILURE':
                case 'NOT_INTERESTED:BLOCKED':
                case 'NOT_APPLICABLE:':
                    textStyle = 'text-muval-brown-1';
                    bgStyle = 'bg-muval-brown-2';
                    break;
                // grey - fallback
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
            }
            break;
        case 'INVENTORY_HISTORY':
            switch (stat?.toUpperCase()) {
                case 'PAYMENT_REQUIRED':
                case 'REFUND_REQUIRED':
                    textStyle = 'text-muval-brand';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'PAYMENT_PROCESSED':
                case 'REFUND_PROCESSED':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
            }
            break;
        case 'SUBSCRIPTION':
            switch (stat?.toUpperCase()) {
                case 'ACTIVE':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'INCOMPLETE':
                    textStyle = 'text-muval-amber';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'INCOMPLETE_EXPIRED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'TRIALING':
                    textStyle = 'text-muval-blue-1';
                    bgStyle = 'bg-muval-blue-2';
                    break;
                case 'PAST_DUE':
                    textStyle = 'text-muval-amber';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'CANCELED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'UNPAID':
                    textStyle = 'text-muval-amber';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'PAUSED':
                    textStyle = 'text-muval-brown-1';
                    bgStyle = 'bg-muval-brown-2';
                    break;
                case 'QUOTED':
                    textStyle = 'text-muval-purple-1';
                    bgStyle = 'bg-muval-purple-2';
                    break;
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
            }
            break;
        case 'ACTION_STATUS':
            switch (stat?.toUpperCase()) {
                case 'TO DO':
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
                case 'IN PROGRESS':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'PAUSED':
                    textStyle = 'text-muval-orange-1';
                    bgStyle = 'bg-muval-orange-2';
                    break;
                case 'COMPLETED':
                    textStyle = 'text-muval-lime-1';
                    bgStyle = 'bg-muval-lime-2';
                    break;
            }
            break;
        case 'JOB_PAYMENT_STATUS':
            switch (stat?.toUpperCase()) {
                case 'UNPAID':
                    textStyle = 'text-muval-red-1';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'DEPOSIT_PAID':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'BALANCE_OWING':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'SETTLED':
                    textStyle = 'text-muval-lime-1';
                    bgStyle = 'bg-muval-lime-2';
                    break;
                case 'OVERPAID':
                    textStyle = 'text-muval-pink-1';
                    bgStyle = 'bg-muval-pink-2';
                    break;
            }
            break;
        default:
            switch (stat?.toUpperCase()) {
                case 'NO MATCHES':
                    textStyle = 'text-muval-brown-1';
                    bgStyle = 'bg-muval-brown-2';
                    break;
                case 'QUOTED':
                    textStyle = 'text-muval-purple-1';
                    bgStyle = 'bg-muval-purple-2';
                    break;
                case 'PENDING':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'BOOKED':
                    textStyle = 'text-muval-dusk-2';
                    bgStyle = 'bg-muval-sky-2';
                    break;
                case 'ACCEPTED':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'READY':
                    textStyle = 'text-muval-dusk-2';
                    bgStyle = 'bg-muval-sky-2';
                    break;
                case 'COMPLETED':
                    textStyle = 'text-muval-lime-1';
                    bgStyle = 'bg-muval-lime-2';
                    break;
                case 'DECLINED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'APPROVED':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'DRAFT':
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
                    break;
                case 'REJECTED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'ON HOLD':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                case 'URGENT':
                    textStyle = 'text-muval-pink-1';
                    bgStyle = 'bg-muval-pink-2';
                    break;
                case 'BOOK NOW':
                    textStyle = 'text-muval-purple-1';
                    bgStyle = 'bg-muval-purple-2';
                    break;
                case 'BROWSING':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-lime-2';
                    break;
                case 'DISCUSS OPTIONS':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'THREE MONTHS PLUS':
                    textStyle = 'text-muval-blue-1';
                    bgStyle = 'bg-muval-blue-2';
                    break;
                case 'REFERRAL':
                    textStyle = 'text-muval-dusk-2';
                    bgStyle = 'bg-muval-blue-2';
                    break;
                case 'RETURN CUSTOMER':
                    textStyle = 'text-muval-dusk-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'CONFIRMED':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'UNSCHEDULED':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'UNPAID':
                    textStyle = 'text-muval-amberr';
                    bgStyle = 'bg-muval-amber/30';
                    break;
                case 'PAID':
                    textStyle = 'text-muval-green-1';
                    bgStyle = 'bg-muval-green-2';
                    break;
                case 'PROCESSING':
                    textStyle = 'text-muval-blue-1';
                    bgStyle = 'bg-muval-blue-2';
                    break;
                case 'FAILED':
                    textStyle = 'text-muval-error';
                    bgStyle = 'bg-muval-red-2';
                    break;
                default:
                    textStyle = 'text-muval-gray-1';
                    bgStyle = 'bg-muval-gray-5';
            }
            break;
    }
    return { textStyle, bgStyle, classes: `${textStyle} ${bgStyle}` };
}

/**
 * @param {MaybeRef<string>} status
 * @param {{type: ?string}} options
 * @returns {{textStyle: Ref<string>, bgStyle: Ref<string>}}
 */
export function useStatusColours(status, options = { type: null }) {
    const textStyle = ref('');
    const bgStyle = ref('');

    function execute() {
        const { textStyle: ts, bgStyle: bs } = getStatusColours(unref(status), options);
        textStyle.value = ts;
        bgStyle.value = bs;
    }

    watch(() => unref(status), execute, {
        immediate: true,
    });

    return { textStyle, bgStyle };
}
